export const headerConfig = [
  {
    id: "home",
    title: "Home",
    url: "/",
  },
  {
    id: "certificates",
    title: "Certificates",
    url: "/certificates",
  },
  {
    id: "projects",
    title: "Projects",
    url: "/projects",
    // items: [
    //   {
    //     id: "ongoing",
    //     title: "On-Going",
    //     url: "/projects",
    //   },
    //   {
    //     id: "completed",
    //     title: "Completed",
    //     url: "/projects",
    //   },
    // ],
  },
  {
    id: "subsidiary",
    title: "Subsidiary",
    url: "/subsidiary",

    items: [
      {
        id: "roadsAndAsphalts",
        title: "Roads and Asphalts",
        url: "/roadsAndAsphalts",
      },
      {
        id: "importAndExports",
        title: "Import And Exports",
        url: "/importAndExports",
      },
    ],
  },
  {
    id: "gallery",
    title: "Gallery",
    url: "/gallery",
  },
  {
    id: "aboutUs",
    title: "About Us",
    url: "/aboutUs",

    items: [
      {
        id: "aboutTheCompany",
        title: "About The Company",
        url: "/aboutUs",
      },
      {
        id: "banksAndInsurances",
        title: "Banks & Insurances",
        url: "/banksAndInsurances",
      },
      {
        id: "eventsAndSeminars",
        title: "Events & Seminars",
        url: "/eventsAndSeminars",
      },
      {
        id: "machineryEquipments",
        title: "Machinery Equipments",
        url: "/machineryEquipments",
      },
    ],
  },
  {
    id: "contact",
    title: "Contact",
    url: "/contactUs",
  },
];
